import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import TabLenguaje from './TabLenguaje';
import CodeContent from './CodeContent';
import Tabla from './Tabla';
import EndpointContent from './EndpointContent';
import TablaTipoComprobante from './TablaTipoComprobante';

function createData(
  campo,
  Tipo,
  valorEjemplo,
  Descripcion
) {
  return { campo, Tipo, valorEjemplo, Descripcion };
}
const Emision = () => {
  const [t] = useTranslation('global');

  const rows = [
    createData('ID','Number',"123",t('content.datosEmision.ID')),
    createData('Sucursal','int',"1",t('content.datosEmision.Sucursal')),
    createData('IGVPorcentaje','Decimal',"18",t('content.datosEmision.IGVPorcentaje')),
    createData('DescuentoGlobalMonto','Decimal',"8.47",t('content.datosEmision.DescuentoGlobalMonto')),
    createData('CargoGlobalPorcentaje','Decimal',"0",t('content.datosEmision.CargoGlobalPorcentaje')),
    createData('CargoGlobalIndicadorCargos','Bool',"true",t('content.datosEmision.CargoGlobalIndicadorCargos')),
    createData('CargoGlobalCodigoMotivo','string',"46",t('content.datosEmision.CargoGlobalCodigoMotivo')),
    createData('OrigenSistema','int',"7",t('content.datosEmision.OrigenSistema')),
    createData('CondicionPago','string',"Contado",t('content.datosEmision.CondicionPago')),
    createData('ClienteTipoDocIdentidadCodigo','string',"6",t('content.datosEmision.ClienteTipoDocIdentidadCodigo')),
    createData('ClienteNumeroDocIdentidad','string',"20200200201",t('content.datosEmision.ClienteNumeroDocIdentidad')),
    createData('ListaDetalles','Array',"[ ComprobanteDetalle1, ComprobanteDetalle2 ]",t('content.datosEmision.ListaDetalles')),
    createData('ExoneradaXML','Decimal',"0",t('content.datosEmision.ExoneradaXML')),
    createData('InafectoXML','Decimal',"0",t('content.datosEmision.InafectoXML')),
    createData('ExportacionXML','Decimal',"0",t('content.datosEmision.ExportacionXML')),
    createData('ImporteTotalTexto','string',"VEINTE CON 00/100 SOLES",t('content.datosEmision.ImporteTotalTexto')),
    createData('DescuentoGlobalMontoBase','Decimal',"16.949",t('content.datosEmision.DescuentoGlobalMontoBase')),
    createData('DescuentoGlobalNGMonto','Decimal',"0",t('content.datosEmision.DescuentoGlobalNGMonto')),
    createData('DescuentoGlobalNGMontoBase','Decimal',"0",t('content.datosEmision.DescuentoGlobalNGMontoBase')),
    createData('AnticiposGravado','Decimal',"0",t('content.datosEmision.AnticiposGravado')),
    createData('AnticiposExonerado','Decimal',"0",t('content.datosEmision.AnticiposExonerado')),
    createData('AnticiposInafecto','Decimal',"0",t('content.datosEmision.AnticiposInafecto')),
    createData('CargoGlobalMonto','Decimal',"0",t('content.datosEmision.CargoGlobalMonto')),
    createData('CargoGlobalMontoBase','Decimal',"10.00",t('content.datosEmision.CargoGlobalMontoBase')),
    createData('ISCBase','Decimal',"0",t('content.datosEmision.ISCBase')),
    createData('GratuitoGravado','Decimal',"10",t('content.datosEmision.GratuitoGravado')),
    createData('TotalPrecioVenta','Decimal',"10",t('content.datosEmision.TotalPrecioVenta')),
    createData('TotalValorVenta','Decimal',"8.47457",t('content.datosEmision.TotalValorVenta')),
    createData('ListaMovimientos','Array',"[ MovimientoCuenta1, MovimientoCuenta2]",t('content.datosEmision.ListaMovimientos')),
    createData('CreditoTotal','Decimal',"10",t('content.datosEmision.CreditoTotal')),
    createData('TipoDocumentoCodigo','string',"01",t('content.datosEmision.TipoDocumentoCodigo')),
    createData('Serie','string',"F001",t('content.datosEmision.Serie')),
    createData('Correlativo','int',"0001",t('content.datosEmision.Correlativo')),
    createData('MonedaCodigo','string',"PEN",t('content.datosEmision.MonedaCodigo')),
    createData('FechaEmision','string',"30/05/2022",t('content.datosEmision.FechaEmision')),
    createData('CorrelativoModificado','string',"156",t('content.datosEmision.CorrelativoModificado')),
    createData('TipoNotaCreditoCodigo','string',"01",t('content.datosEmision.TipoNotaCreditoCodigo')),
    createData('TipoNotaDebitoCodigo','string',"01",t('content.datosEmision.TipoNotaDebitoCodigo')),
    createData('TipoOperacionCodigo','string',"0101",t('content.datosEmision.TipoOperacionCodigo')),
    createData('TipoCambio','Number',"3.78",t('content.datosEmision.TipoCambio')),
    createData('ClienteNombreRazonSocial','string',"Libertad S.A.",t('content.datosEmision.ClienteNombreRazonSocial')),
    createData('ClienteDireccion','string',"Av. Siempre Viva 666",t('content.datosEmision.ClienteDireccion')),
    createData('DescuentoGlobalPorcentaje','Decimal',"50",t('content.datosEmision.DescuentoGlobalPorcentaje')),
    createData('DescuentoGlobalValor','Decimal',"10",t('content.datosEmision.DescuentoGlobalValor')),
    createData('Observacion','string',"Regularización del anticipo",t('content.datosEmision.Observacion')),
    createData('Gravado','Decimal',"8.4745",t('content.datosEmision.Gravado')),
    createData('Exonerada','Decimal',"0",t('content.datosEmision.Exonerada')),
    createData('TipoDocumentoCodigoModificado','String',"01",t('content.datosEmision.TipoDocumentoCodigoModificado')),
    createData('SerieModificado','String',"F001",t('content.datosEmision.SerieModificado')),
    createData('Inafecto','Decimal',"0",t('content.datosEmision.Inafecto')),
    createData('Exportacion','Decimal',"0",t('content.datosEmision.Exportacion')),
    createData('Gratuito','Decimal',"0",t('content.datosEmision.Gratuito')),
    createData('TotalDescuentos','Decimal',"8.47457",t('content.datosEmision.TotalDescuentos')),
    createData('TotalAnticipos','Decimal',"0",t('content.datosEmision.TotalAnticipos')),
    createData('ISC','decimal',"39.996399",t('content.datosEmision.ISC')),
    createData('IGV','Decimal',"1.525",t('content.datosEmision.IGV')),
    createData('ICBPER','Decimal',"0",t('content.datosEmision.ICBPER')),
    createData('ImpuestoTotal','Decimal',"1.525",t('content.datosEmision.ImpuestoTotal')),
    createData('TotalOtrosCargos','Decimal',"1.525",t('content.datosEmision.TotalOtrosCargos')),
    createData('TotalImporteVenta','Decimal',"10",t('content.datosEmision.TotalImporteVenta')),
    createData('TotalPago','Decimal',"10",t('content.datosEmision.TotalPago')),
    createData('PendientePago','Decimal',"10",t('content.datosEmision.PendientePago'))
   ];
  /* JSON PARA DATOS NECESARIOS PARA CADA COMPROBANTE*/
  const JsonFactura =
    `
    {
      "ID": 0,
      "Sucursal": "3691",
      "IGVPorcentaje": 18,
      "DescuentoGlobalMonto": 0,
      "CargoGlobalPorcentaje": 0,
      "CargoGlobalIndicadorCargos": 0,
      "CargoGlobalCodigoMotivo": 0,
      "OrigenSistema": 7,
      "CondicionPago": "Contado",
      "ClienteTipoDocIdentidadCodigo": "6",
      "ClienteNumeroDocIdentidad": "20600598334",
      "ListaDetalles": [],
      "ExoneradaXML": 0,
      "InafectoXML": 0,
      "ExportacionXML": 0,
      "ImporteTotalTexto": "CIENTO DIECIOCHO CON 00/100 DOLARES",
      "DescuentoGlobalMontoBase": 100,
      "DescuentoGlobalNGMonto": 0,
      "DescuentoGlobalNGMontoBase": 0,
      "AnticiposGravado": 0,
      "AnticiposExonerado": 0,
      "AnticiposInafecto": 0,
      "CargoGlobalMonto": 0,
      "CargoGlobalMontoBase": 100,
      "ISCBase": 0,
      "GratuitoGravado": 0,
      "TotalPrecioVenta": 118,
      "TotalValorVenta": 100,
      "ListaMovimientos": [],
      "CreditoTotal": 0,
      "TipoDocumentoCodigo": "01",
      "Serie": "F002",
      "Correlativo": 1872,
      "MonedaCodigo": "USD",
      "FechaEmision": "13/02/2023",
      "TipoDocumentoCodigoModificado": "01",
      "SerieModificado": "",
      "CorrelativoModificado": "",
      "TipoNotaCreditoCodigo": "01",
      "TipoNotaDebitoCodigo": "01",
      "TipoOperacionCodigo": "0101",
      "TipoCambio": "3.919",
      "ClienteNombreRazonSocial": "RAPIFAC SOCIEDAD ANONIMA - RAPIFAC S.A.",
      "ClienteDireccion": "CAL. HIPOLITO UNANUE MZ. B LT. 1 URB. LAS MALVINAS - CUSCO - CUSCO - SANTIAGO",
      "DescuentoGlobalPorcentaje": 0,
      "DescuentoGlobalValor": 0,
      "Observacion": "",
      "Gravado": 100,
      "Exonerada": 0,
      "Inafecto": 0,
      "Exportacion": 0,
      "Gratuito": 0,
      "TotalDescuentos": 0,
      "TotalAnticipos": 0,
      "ISC": 0,
      "IGV": 18,
      "ICBPER": 0,
      "ImpuestoTotal": 18,
      "TotalOtrosCargos": 0,
      "TotalImporteVenta": 118,
      "TotalPago": 118,
      "PendientePago": "118.00"
  }
    `
  ;
  const JsonBoleta =
    `
    {
      "Usuario": "20190306",
      "Sucursal": "3677",
      "IGVPorcentaje": 18,
      "DescuentoGlobalMonto": 0,
      "CargoGlobalIndicadorCargos": 0,
      "CargoGlobalPorcentaje": 0,
      "CargoGlobalCodigoMotivo": 0,
      "OrigenSistema": 7,
      "CanalVenta": 2,
      "Vendedor": "20190306",
      "CondicionPago": "Contado",
      "Ubigeo": "150115",
      "ClienteTipoDocIdentidadCodigo": "-",
      "ClienteNumeroDocIdentidad": "10000000",
      "ListaDetalles": [],
      "ExoneradaXML": 0,
      "InafectoXML": 0,
      "ExportacionXML": 0,
      "ImporteTotalTexto": "DOSCIENTOS SESENTA Y SEIS CON 00/100 SOLES",
      "DescuentoGlobalMontoBase": 225.423728,
      "DescuentoGlobalNGMonto": 0,
      "DescuentoGlobalNGMontoBase": 0,
      "DescuentoNGMonto": 0,
      "CargoGlobalMonto": 0,
      "CargoGlobalMontoBase": 225.423728,
      "ISCBase": 0,
      "GratuitoGravado": 0,
      "TotalPrecioVenta": 266,
      "TotalValorVenta": 225.423728,
      "ListaMovimientos": [],
      "CreditoTotal": 0,
      "TipoDocumentoCodigo": "03",
      "Serie": "B001",
      "Correlativo": 6000,
      "MonedaCodigo": "PEN",
      "FechaEmision": "22/02/2023",
      "TipoDocumentoCodigoModificado": "01",
      "TipoOperacionCodigo": "0101",
      "TipoCambio": "3.919",
      "ClienteNombreRazonSocial": "CLIENTES VARIOS",
      "DescuentoGlobalPorcentaje": 0,
      "DescuentoGlobalValor": 0,
      "Observacion": "",
      "Gravado": 225.423728,
      "Exonerada": 0,
      "Inafecto": 0,
      "Gratuito": 0,
      "TotalDescuentos": 0,
      "DescuentoGlobal": 0,
      "TotalAnticipos": 0,
      "ISC": 0,
      "IGV": 40.576271,
      "ICBPER": 0,
      "TotalOtrosCargos": 0,
      "TotalImporteVenta": 266,
      "PercepcionTotal": 0,
      "TotalPago": 266,
      "MontoRetencion": 0,
      "PendientePago": "266.00"
    }
    
    `
  ;
  const JsonNotaCredito =
    `
    {
      "ID": 0,
      "Usuario": "20190306",
      "Sucursal": "3677",
      "IGVPorcentaje": 18,
      "DescuentoGlobalMonto": 0,
      "CargoGlobalPorcentaje": 0,
      "CargoGlobalIndicadorCargos": "0.000000",
      "CargoGlobalCodigoMotivo": "0",
      "OrigenSistema": 7,
      "OrigenSistema": 0,
      "CanalVenta": "2",
      "Vendedor": "20190306",
      "CondicionPago": "Contado",
      "Ubigeo": "150115",
      "SeCambiaFecha": 0,
      "ClienteTipoDocIdentidadCodigo": "6",
      "ClienteNumeroDocIdentidad": "10428985783",
      "ListaMovimientos": [],
      "ListaDetalles": [],
      "ExoneradaXML": 0,
      "InafectoXML": 0,
      "ExportacionXML": 0,
      "ImporteTotalTexto": "QUINCE CON 00/100 SOLES",
      "Detraccion": 0,
      "DescuentoGlobalMontoBase": 12.711864,
      "DescuentoGlobalNGMonto": 0,
      "DescuentoGlobalNGMontoBase": 0,
      "DescuentoNGMonto": 0,
      "AnticiposGravado": 0,
      "AnticiposExonerado": 0,
      "AnticiposInafecto": 0,
      "CargoGlobalMonto": 0,
      "CargoGlobalMontoBase": 12.711864,
      "ISCBase": 0,
      "GratuitoGravado": 0,
      "TotalPrecioVenta": 15,
      "TotalValorVenta": 12.711864,
      "CreditoTotal": 0,
      "DesdeOrden": false,
      "TipoPrecio": "0",
      "TipoDocumentoCodigo": "07",
      "Serie": "FC01",
      "Correlativo": 1129,
      "MonedaCodigo": "PEN",
      "FechaEmision": "23/02/2023",
      "TipoDocumentoCodigoModificado": "01",
      "SerieModificado": "F001",
      "CorrelativoModificado": "11392",
      "TipoNotaCreditoCodigo": "01",
      "TipoNotaDebitoCodigo": "01",
      "TipoOperacionCodigo": "0101",
      "TipoCambio": 3.919,
      "MotivoTrasladoCodigo": "01",
      "ClienteNombreRazonSocial": "CACERES PILLACA ABAT",
      "ClienteDireccion": "JR. ARENALES LT. 14 MZ. C - PICHARI - LA CONVENCION - CUSCO",
      "DescuentoGlobalPorcentaje": 0,
      "DescuentoGlobalValor": 0,
      "Observacion": "ANULACIÓN DE LA OPERACIÓN",
      "Gravado": 12.711864,
      "Exonerada": 0,
      "Inafecto": 0,
      "Exportacion": 0,
      "Gratuito": 0,
      "TotalDescuentos": 0,
      "TotalAnticipos": 0,
      "ISC": 0,
      "IGV": 2.288135,
      "ICBPER": 0,
      "ImpuestoTotal": 2.288135,
      "TotalOtrosCargos": 0,
      "TotalImporteVenta": 15,
      "PercepcionTotal": 0,
      "TotalPago": 15,
      "Leyenda": 0,
      "DocAdicionalCodigo": 1,
      "DocAdicionalDetalle": "",
      "MontoRetencion": 0,
      "PendientePago": "15.00",
      "FechaIngresoPais": "23/02/2023",
      "FechaIngresoEstablecimiento": "23/02/2023",
    }
    `
  ;
  const JsonNotaDebito =
    `
    
    {
      "Usuario": "20190306",
      "Sucursal": "3677",
      "IGVPorcentaje": 18,
      "DescuentoGlobalMonto": 0,
      "CargoGlobalPorcentaje": 0,
      "CargoGlobalIndicadorCargos": "0.000000",
      "CargoGlobalCodigoMotivo": "0",
      "OrigenSistema": 7,
      "OrigenSistema": 0,
      "Vendedor": "15151515",
      "CondicionPago": "Contado",
      "Ubigeo": "150115",
      "ClienteTipoDocIdentidadCodigo": "6",
      "ClienteNumeroDocIdentidad": "10069271761",
      "ListaDetalles": [],
      "ExoneradaXML": 0,
      "InafectoXML": 0,
      "ExportacionXML": 0,
      "ImporteTotalTexto": "QUINCE CON 00/100 SOLES",
      "DescuentoGlobalMontoBase": 12.711864,
      "DescuentoGlobalNGMonto": 0,
      "DescuentoGlobalNGMontoBase": 0,
      "DescuentoNGMonto": 0,
      "CargoGlobalMonto": 0,
      "CargoGlobalMontoBase": 12.711864,
      "ISCBase": 0,
      "GratuitoGravado": 0,
      "TotalPrecioVenta": 15,
      "TotalValorVenta": 12.711864,
      "ListaMovimientos": [],
      "CreditoTotal": 0,
      "TipoDocumentoCodigo": "08",
      "Serie": "FD01",
      "Correlativo": 78,
      "MonedaCodigo": "PEN",
      "FechaEmision": "22/02/2023",
      "TipoDocumentoCodigoModificado": "01",
      "SerieModificado": "F001",
      "CorrelativoModificado": "11381",
      "TipoNotaCreditoCodigo": "01",
      "TipoNotaDebitoCodigo": "02",
      "TipoOperacionCodigo": "0101",
      "TipoCambio": "3.919",
      "ClienteNombreRazonSocial": "CANTORIN PASCUAL JOHN WILLY",
      "ClienteDireccion": "-",
      "DescuentoGlobalPorcentaje": 0,
      "DescuentoGlobalValor": 0,
      "Observacion": "AUMENTO EN EL VALOR",
      "Gravado": 12.711864,
      "Exonerada": 0,
      "Inafecto": 0,
      "Gratuito": 0,
      "TotalDescuentos": 0,
      "DescuentoGlobal": 0,
      "TotalAnticipos": 0,
      "IGV": 2.288135,
      "ICBPER": 0,
      "ImpuestoTotal": 2.288135,
      "TotalOtrosCargos": 0,
      "TotalImporteVenta": 15,
      "PercepcionTotal": 0,
      "TotalPago": 15,
      "MontoRetencion": 0,
      "PendientePago": "15.00"
    }
  
    `
  ;

  const cCurl =
    `  
            curl --location 'https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1' 
            --header 'Authorization: bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...'  //se agrega bearer y el token obtenido en la autentificación 
            --header 'Content-Type: application/json' 
            --data '{ /* Datos del comprobante */ }'
        `;
  const csRS =
        `   
            var options = new RestClientOptions("")
            {
             MaxTimeout = -1,
            };
            var client = new RestClient(options);
            var request = new RestRequest("https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1", Method.Post);
            request.AddHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...");
            request.AddHeader("Content-Type", "application/json");
            var body = @"{ ./* Datos del comprobante*/ }";
            request.AddStringBody(body, DataFormat.Json);
            RestResponse response = await client.ExecuteAsync(request);
            Console.WriteLine(response.Content);
          `;
  const javaOK =
    `        
            OkHttpClient client = new OkHttpClient().newBuilder()
             .build();
            MediaType mediaType = MediaType.parse("application/json");
            RequestBody body = RequestBody.create(mediaType, "{ /* Datos del comprobante */ }");
            Request request = new Request.Builder()
             .url("https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1")
             .method("POST", body)
             .addHeader("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3Lncz...")
             .addHeader("Content-Type", "application/json")
             .build();
            Response response = client.newCall(request).execute();
            `
    ;
  const phpHC =
    `
            <?php
            require_once 'HTTP/Request2.php';
            $request = new HTTP_Request2();
            $request->setUrl('https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1');
            $request->setMethod(HTTP_Request2::METHOD_POST);
            $request->setConfig(array(
            'follow_redirects' => TRUE
            ));
            $request->setHeader(array(
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD',
            '' => '',
            'Content-Type' => 'application/json'
            ));
            $request->setBody('{ /* Datos del comprobante*/ }');
            try {
            $response = $request->send();
            if ($response->getStatus() == 200) {
                echo $response->getBody();
            }
            else {
                echo 'Unexpected HTTP status: ' . $response->getStatus() . ' ' .
                $response->getReasonPhrase();
            }
            }
            catch(HTTP_Request2_Exception $e) {
            echo 'Error: ' . $e->getMessage();
            }
    `;
  const csHTC =
    `         
            var client = new HttpClient();
            var request = new HttpRequestMessage(HttpMethod.Post, "https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1");
            request.Headers.Add("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD...");
            request.Headers.Add("", "");
            var content = new StringContent("/* datos del comprobante */", null, "application/json");
            request.Content = content;
            var response = await client.SendAsync(request);
            response.EnsureSuccessStatusCode();
            Console.WriteLine(await response.Content.ReadAsStringAsync());
          
          `;
  const javaUNI =
    `        
            Unirest.setTimeouts(0, 0);
            HttpResponse<String> response = Unirest.post("https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1")
            .header("Authorization", "bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD...")
            .header("", "")
            .header("Content-Type", "application/json")
            .body("{/* datos del comprobante */}")
            .asString();
          `;
  const phpGZ =
    `     
            <?php
            $client = new Client();
            $headers = [
            'Authorization' => 'bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMD',
            '' => '',
            'Content-Type' => 'application/json'
            ];
            $body = '{
                /*Datos del comprobante*/
            }';
            $request = new Request('POST', 'https://wsventas-exp.rapifac.com/v0/comprobantes?IncluirCDR=1', $headers, $body);
            $res = $client->sendAsync($request)->wait();
            echo $res->getBody();
          `;
  return (
    <div id='Emision'>
      <Divider sx={{ height: '70px' }} />
      <Typography variant="h3" id="emisionComprobante" gutterBottom>
        {t('content.emision.titulo')}
      </Typography>
      {/*<Typography variant="h5" id="emision" gutterBottom>
        {t('content.emision.subTitulo')}
      </Typography>*/}
      
      <Typography variant="body1" id="" gutterBottom>
        {t('content.emision.texto')}
      </Typography>
      <EndpointContent method='POST' path='https://wsventas-exp.rapifac.com/v0/comprobantes'/>

      <TabLenguaje  curl={cCurl} csRS ={csRS} javaOK={javaOK} phpRQ={phpHC} csHC={csHTC} java2UN={javaUNI} php2GZ={phpGZ} >
      </TabLenguaje>
      <br id={"emisionObjeto"}/>
      <br/>
      <br/>
      <Typography variant="h5"  id="" gutterBottom>
        {t('content.emision.subtituloObjeto')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('content.emision.datosComprobante')}
      </Typography>
       {/*<CodeContent code={datos} />*/}
       <TablaTipoComprobante Factura={JsonFactura} NombreFactura={t('content.factura.titulo')} Boleta={JsonBoleta} NombreBoleta={t('content.boleta.titulo')} NotaCredito={JsonNotaCredito} NombreNotaCredito={t('content.notaCredito.titulo')} NotaDebito={JsonNotaDebito} NombreNotaDebito={t('content.notaDebito.titulo')}></TablaTipoComprobante>
      <br id={"emisionDescripcion"}/>
      <br/>
      <br/>
      <Typography variant="h5" gutterBottom>
        {t('content.emision.subtituloTabla')}
      </Typography>
      
      <Tabla rows={rows}/>
    </div>
  );
}
export default Emision